import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { Copy } from 'components/components/atoms';
import getEmbedUrl from 'utils/getEmbedUrl';
import { AspectRatio } from 'react-aspect-ratio';
import {
  videoTranscriptFileUrl,
  videoTranscriptFileExtension,
} from 'utils/videoTranscriptFileUrl';
import { isValidUrl } from 'utils/validateUrlSrc';
import { isValidTitle } from 'utils/validateTitle';

const SectionHeading = styled.h2`
  letter-spacing: -0.01em;
`;
const VideoDescriptionContainer = styled.div`
  box-shadow: rgba(0, 0, 0, 0.3) 2px 2px 25px;
`;

const VideoGalleyVideo = ({ videoSelected }) => {
  const title = videoSelected.title;
  const text = videoSelected.copy;
  const video = videoSelected.video;
  const videoTranscriptDescription = videoSelected.transcriptText;
  const videoTranscript = videoSelected.transcript;
  const autoPlay = videoSelected.autoPlay;

  return (
    <div className={cx('flex flex-col w-full', {})}>
      <AspectRatio ratio='1150/650' className='w-full' tabIndex='0'>
        <div
          className='w-full justify-center text-center'
          key={video && video.id}
        >
          {video &&
            video.type &&
            (video.type === 'external' ? (
              <iframe
                className='w-full h-full bg-white'
                src={getEmbedUrl(video.href, autoPlay)}
                title={videoTranscriptDescription}
                frameBorder='0'
                allowFullScreen
              />
            ) : (
              isValidUrl(video.href) && (
                <video
                  className='w-full h-full bg-white'
                  src={video.href}
                  controls
                  disablePictureInPicture='true'
                  controlsList='nodownload'
                  autoPlay={autoPlay}
                  muted
                  loop
                />
              )
            ))}
        </div>
      </AspectRatio>
      <VideoDescriptionContainer className='w-full'>
        <div className='mx-4 md:mx-16 mt-6 md:mt-2 mb-8 md:mb-16'>
          {video &&
            video.type &&
            videoTranscriptDescription &&
            videoTranscript &&
            videoTranscript.link &&
            videoTranscript.link.href && (
              <span className='richtext text-left text-base leading-7 font-graphie text-mattamy-blue'>
                {'Transcript: '}
                <a
                  href={videoTranscriptFileUrl(videoTranscript)}
                  download={
                    videoTranscript.name +
                    videoTranscriptFileExtension(videoTranscript.extension)
                  }
                  className='underline'
                  aria-label={
                    'Download ' + videoTranscriptDescription + ' transcript'
                  }
                >
                  {videoTranscriptDescription}
                </a>
              </span>
            )}

          {isValidTitle(title) && (
            <SectionHeading className='pt-6 md:mt-8 font-bold font-trade-gothic-20 text-2xl md:text-3xl mb-3 text-action-blue leading-tiny'>
              {title}
            </SectionHeading>
          )}

          <Copy color='blue' className='pb-10 md:pb-4 leading-relaxed'>
            {text}
          </Copy>
        </div>
      </VideoDescriptionContainer>
    </div>
  );
};

export default VideoGalleyVideo;
